module.exports = __webpack_public_path__ + "static/media/4.8d1eb60a.jpg";